import headerStyle from './header.module.css';
import logo from '../assets/logo.svg';
import { Link } from 'react-router-dom';
import { HOMEPAGE_URL } from '../constants/SocialTypes';

function Header() {
    return (
        <>
            <header className={headerStyle.header + ' py-3 px-5'}>
                <Link to={HOMEPAGE_URL} className={headerStyle.imgLogo}>
                    <img src={logo} className={headerStyle.imgLogo} alt="logo" />
                </Link>
            </header>
            <div className='text-center mt-4'>
                <h1 className={headerStyle.title}>Get your free Fiducia assessment</h1>
                <h2 className={headerStyle.subtitle}>
                    Discover how FiduciaPS can help your business save time, reduce errors, and optimize financial management.<br />
                    Complete this short assessment to receive a personalized evaluation and expert guidance tailored to your company’s needs.<br />
                    It only takes a few minutes and your information is completely confidential.
                </h2>
            </div>
        </>
    );
}

export default Header;